// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getFirestore} from 'firebase/firestore';
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";



// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBMR8ObKakLH_zbUvMPeXz-25NkCltpnsQ",
  authDomain: "safeline-5c7bc.firebaseapp.com",
  databaseURL: "https://safeline-5c7bc-default-rtdb.firebaseio.com",
  projectId: "safeline-5c7bc",
  storageBucket: "safeline-5c7bc.firebasestorage.app",
  messagingSenderId: "777769026277",
  appId: "1:777769026277:web:a953c94733282f78478a0c",
  measurementId: "G-NSSS07CHV0"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export const auth = getAuth(app);